import * as React from 'react'
import styled from 'styled-components'
import { animated, useSpring } from '@react-spring/web'

const StyledButton = styled(animated.button)`
  --x: 0;
  --y: 0;
  --scale: scale(1);

  text-transform: uppercase;
  font-size: 12px;
  font-weight: 400;
  line-height: 12px;

  margin: 0 8px 8px;
  padding: 8px 16px;
  height: 32px;

  border-radius: 3px;
  border: none;

  color: #fff;
  overflow: hidden;
  position: relative;
  cursor: pointer;
  z-index: 1;
  &:before {
    z-index: -1;
    background: #1976d2;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
  }
  &:disabled:before {
    background: #ccc;
  }
  &:after,
  &:before {
    content: '';
    position: absolute;
  }
  &:after {
    z-index: -1;
    transform: var(--scale);
    left: var(--x);
    top: var(--y);
    width: 20px;
    height: 20px;
    background: #63a4ff;
    display: block;
    border-radius: 9999px;
    opacity: var(--opacity);
  }
`

type ButtonProps = {
  [key in 'onClick' | 'onMouseMove' | 'onMouseDown']?: (
    e: React.MouseEvent
  ) => void
} & {
  disabled?: boolean
}

export const Button: React.FC<ButtonProps> = ({
  children,
  onClick,
  onMouseMove,
  onMouseDown,
  disabled,
  style,
  ...props
}) => {
  const [{ opacity, scale }, set] = useSpring(() => ({
    opacity: 0,
    scale: 1
  }))
  const [{ x, y }, setCoord] = useSpring(() => ({ x: 0, y: 0 }))
  return (
    <StyledButton
      {...{
        disabled,
        style: {
          '--x': x.to((x) => x + 'px'),
          '--y': y.to((y) => y + 'px'),
          '--opacity': opacity,
          '--scale': scale.to((s) => `scale(${s})`),
          ...style
        },
        onMouseMove: (e: React.MouseEvent<HTMLElement>) => {
          const rect = (e.target as HTMLElement).getBoundingClientRect()
          setCoord({
            x: e.clientX - rect.left - 10,
            y: e.clientY - rect.top - 10,
            immediate: true
          })
          onMouseMove && onMouseMove(e)
        },
        onMouseDown: (e: React.MouseEvent) => {
          set({ opactiy: 1, scale: 1, immediate: true })
          onMouseDown && onMouseDown(e)
        },
        onClick: (e: React.MouseEvent) => {
          set({
            to: [
              {
                scale: 1,
                opacity: 1,
                immediate: true
              },
              {
                scale: 1,
                opacity: 1
              },
              { opacity: 0.375, scale: 10 },
              { opacity: 0, scale: 35 }
            ]
          })
          onClick && onClick(e)
        },
        ...props
      }}
    >
      {children}
    </StyledButton>
  )
}
